import script from "./ProgrammeOnline25June.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgrammeOnline25June.vue?vue&type=script&setup=true&lang=js"

import "./ProgrammeOnline25June.vue?vue&type=style&index=0&id=747ce4e9&lang=css"

const __exports__ = script;

export default __exports__